module.exports = __webpack_public_path__ + "img/hosting-solutionsimg-1.0dc2392a.png";